import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';
import ProtectionPlanButtonAndModal from 'components/consumer/ProtectionPlanButtonAndModal';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import useResetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useResetPdpSelectedProtectionPlanId';

const PDPProtectionPlanSelectorUI = ({
  allProtectionPlanTypes,
  loading,
  meta,
  onProtectionPlanSelection,
}) => {
  const [isProtectionModalOpen, setIsProtectionModalOpen] = useState(false);

  const openProtectionModal = useCallback(() => {
    setIsProtectionModalOpen(true);
  }, []);

  const closeProtectionModal = useCallback(() => {
    setIsProtectionModalOpen(false);
  }, []);

  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  const resetPdpSelectedProtectionPlanId = useResetPdpSelectedProtectionPlanId();

  if (loading) {
    return (
      <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full">
        <Placeholder type="rect" loading style={{ height: '52px' }} />
      </div>
    );
  }

  const selectedProtectionPlan = pdpSelectedProtectionPlanId
    ? allProtectionPlanTypes.filter(
        singlePlan => singlePlan.plan_id === pdpSelectedProtectionPlanId
      )?.[0]
    : null;

  const eligible_plans = allProtectionPlanTypes
    ? allProtectionPlanTypes.filter(singlePlan =>
        meta?.eligible_protection_planids.includes(singlePlan.plan_id)
      )
    : [];

  return (
    <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full">
      <h3 className="text-base font-bold mt-0 mx-0 mb-1.5">
        Protect Your Investment
      </h3>

      <ProtectionPlanButtonAndModal
        close={closeProtectionModal}
        eligible_plans={eligible_plans}
        forPage="PDP"
        isOpen={isProtectionModalOpen}
        onSelect={onProtectionPlanSelection}
        openModal={openProtectionModal}
        removeProtectionPlan={resetPdpSelectedProtectionPlanId}
        selectedProtectionPlan={selectedProtectionPlan}
      />
    </div>
  );
};

PDPProtectionPlanSelectorUI.propTypes = {
  allProtectionPlanTypes: PropTypes.array,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  onProtectionPlanSelection: PropTypes.func,
};

export default PDPProtectionPlanSelectorUI;
